import React, { Component } from 'react';
import { pure } from 'recompose';
import { withRouter, Route, Switch } from 'react-router-dom';
import Booking from '../booking/Booking';
import withLocalized from '../localization/withLocalized';
import { SubPageContainer} from '../booking/components/BookingSubPage';
import {
  ModalContainer,
  ModalHeader,
  MenuButton,
  ContentContainer,
} from '../common/components/modal/ui/';

import Icon from '../common/components/icon/Icon';
import { ICONS } from '../common/components/icon/Icons';

const eventsPath = '/:list(lectures|events|trips|services)';
const eventPath = `${eventsPath}/:id(\\d+)`;
const bookingPath = `${eventPath}/book/:priceid(\\d+)?`;
const bookingSubPagePath = `${bookingPath}/:subpage(help|terms|complete|error)?`;
//const bookingResultPath = `${bookingPath}/:result(complete|error)`;


class BookingPage extends Component {
  componentDidMount() {
    document.body.classList.add('with-modal');
  }

  componentWillUnmount() {
    document.body.classList.remove('with-modal');
  }

  render() {
    const { match, localized/*onCloseLink*/ } = this.props;
    const linkRoot = match.url.split('/book')[0];
    const onCloseLink = linkRoot;
    const fromWidget = document.location.href.indexOf("embed") !== -1;
    const onCloseClick = () => {
      onCloseLink ? this.props.history.replace(onCloseLink) : this.props.history.replace(`${linkRoot}`);
    }
    return (
      <ModalContainer zIndex="2" first>
        <ModalHeader>
          <MenuButton />
          <h2>{localized('booking.form.modal_title')}</h2>
          { !fromWidget && 
          <MenuButton onClick={onCloseClick}>
            <Icon
              icon={ICONS.CLOSE}
            />
          </MenuButton>
          }
        </ModalHeader>
        <ContentContainer>
          <Booking />
        </ContentContainer>
        <Switch>
          <Route
            path={bookingSubPagePath}
            render={(props) => <SubPageContainer {...props} onCloseLink={onCloseLink} />} />
        </Switch>
      </ModalContainer>
    )
  }
}

export default pure(withLocalized(withRouter(BookingPage)));



// WEBPACK FOOTER //
// ./src/modules/pages/BookingPage.js